import { IHttpService, IPromise } from 'angular';
import HttpService from '../http.service';
import { IPackageService } from './package.service';
import { PackageThumbnail } from './package.model';

/* @ngInject */
export default class ListeningPackageService implements IPackageService {
  constructor(
    private $http: IHttpService,
    private httpService: HttpService,
    private $cookies
  ) {}

  public getPermAndGeneratePassword(
    packet: PackageThumbnail,
    paymentMethodId?: number
  ): IPromise<Response> {
    return this.httpService.extractResponseResult(
      this.$http.get(
        `hafifmuzik/mobile/listeningpackage/getPermAndGeneratePassword/offerid/${packet.relatedSDP}`
      )
    );
  }

  public validatePasswordAndBuy(
    packet: PackageThumbnail,
    password: string,
    paymentMethodId?: number
  ): IPromise<Response> {
    return this.httpService.extractResponseResult(
      this.$http.get(
        `hafifmuzik/mobile/listeningpackage/validatePasswordAndBuy/offerid/${packet.relatedSDP}/password/${password}`
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/package/listeningpackage.service.ts